import FeedbackPage from "./ui/FeedbackPage";
export { FeedbackPage };